import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { SubjectService } from 'src/app/services/subject.service';
import { TrackRequestService } from 'src/app/services/track-request.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';

@Component({
  selector: 'app-account-info',
  templateUrl: './account-info.component.html',
  styleUrls: ['./account-info.component.scss'],
})
export class AccountInfoComponent implements OnInit {
  @Input("data") data: any;
  language: any;
  accountInfoURl:any='';
  accountInfoImage:string = window.location.origin + '/content/dam/dx_eitsalat_ae/en/images/accountID-Desktop.png';


  constructor(
    private modalController: ModalController,
    private SS: SubjectService,
    private translate: TranslateService,
    private route: Router,
    private UTS: UtilitiesService,
    private TRS: TrackRequestService,
  ) {
   
  }

  ngOnInit() {
    this.language = this.UTS.getLocaleLanguage();
    this.accountInfoURl = this.data?.accountInfoUrl;

  }

  dismiss() {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    this.modalController.dismiss({
      dismissed: true,
    });
  }

  
}


